<meta name="viewport" content="width=device-width, initial-scale=1.0">
</meta>
<template>
  <v-content>
    <div class="block" style="display: flex; flex-direction: column;">
      <div class="navDescription" style="flex-grow: 1">
        <h1 style="font-weight: 700;">Scenarios</h1>
        <div>
          Here you can find the different scenarios that are available to interact with. You can see the status of
          each scenario and interact with them by clicking on the card.
        </div>
      </div>
      <v-container style="flex-grow: 1">
        <v-row>
          <v-col v-for="item in sortedItems" :key="item.id" cols="12" sm="6" md="4">
            <v-card :class="item.status === 'online' ? 'online-card' : 'offline-card'" dark class="mx-auto scenario-card" max-width="350" min-height="520" max-height="700"
              :style="item.status === 'offline' ? 'background-color: #3a3a3a;' : 'background-color: #25262D;'" @click="item.status === 'online' && handleNavigation(item.router)">
              <v-img class="white--text align-end" height="200px" :src="item.src" :class="{ 'offline-image': item.status === 'offline' }">
              </v-img>
              <v-card-title :class="['diagonal-top', { 'diagonal-top-offline': item.status === 'offline' }]" style="background-color: transparent; font-weight: 600;">
                {{item.title }}
              </v-card-title>
              <v-card-text style="font-weight: 200;">
                <div>{{ item.description }}</div>
              </v-card-text>
              <v-card-actions>
                <div style="position:absolute; bottom:0; justify-content:center;">
                  <span v-if="item.status == 'online'" class="dotGreen"></span>
                  <span v-else class="dotRed"></span>
                  <span style="margin-left: 5px;">{{ item.status }}</span>
                </div>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </v-content>
</template>

<script>
export default {
  name: "Scenarios",
  data() {
    return {
      items: [
        {
          id: 1,
          title: "SMART HOME SUITCASE",
          description: "This scenario is inspired by a smart home. It is made up of several lights and dimmers installed in a case. The communication of this briefcase is carried out through KNX, but, to allow a more agile interaction and with more traffic, the interaction with the Things is carried out through Digital Dices.",
          status: "offline",
          router: "/scenarios/knxsuitcase",
          src: require("../assets/scenarios/suitcase.png")
        },
        {
          id: 2,
          title: "VIRTUAL THINGS",
          description: "This scenario contains various virtual Things. Most of these Things come in sensor-actuator pairs, such as Bulb-Switch.",
          status: "offline",
          router: "/scenarios/virtualthings",
          src: require("../assets/scenarios/virtualThings.jpg")
        },
        {
          id: 3,
          title: "IIOT - GARBAGE",
          description: "This scenario represents an industrial situation in which there are a fleet of garbage trucks and a group of garbage containers of different types (organic, paper and plastic). There also are routes that can be manually generated from a truck´s interface or be autogenerated by the system.",
          status: "offline",
          router: "/scenarios/containers/map",
          src: require("../assets/scenarios/iiotGarbage.png")
        },
        {
          id: 4,
          title: "LAB SENSORS",
          description: "This scenario represents the various sensors in our laboratory and their different statistics. It includes measurements for brightness, temperature, air quality, and humidity. These sensors help monitor and maintain optimal conditions within the lab environment.",
          status: "online",
          router: "https://acgsaas.ual.es/grafana/public-dashboards/2b05248030cc44e8a412b295f969f12b?orgId=1&from=1733317123942&to=1733319560037&refresh=5m",
          src: require("../assets/scenarios/labSensor.jpg")
        }
      ]
    };
  },
  computed: {
    sortedItems() {
      return this.items.slice().sort((a, b) => {
        if (a.status === 'online' && b.status === 'offline') {
          return -1;
        } else if (a.status === 'offline' && b.status === 'online') {
          return 1;
        } else {
          return 0;
        }
      });
    }
  },
  methods: {
    handleNavigation(url) {
      if (url.startsWith('http')) {
        window.location.href = url;
      } else {
        this.$router.push(url);
      }
    }
  }
};
</script>

<style scoped>
.diagonal-top {
  position: relative;
  padding-top: 20px;
  z-index: 1;
}

.diagonal-top::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 70px;
  background: #25262D;
  transform: skewY(-5deg);
  transform-origin: bottom left;
  z-index: -1;
}

.dotRed {
  height: 10px;
  width: 10px;
  background-color: #DF6451;
  border-radius: 50%;
  display: inline-block;
}

.dotGreen {
  height: 10px;
  width: 10px;
  background-color: #35BC7A;
  border-radius: 50%;
  display: inline-block;
}

.navDescription {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: left;
  padding: 0.5rem;
  margin: 1rem auto; /* auto margins for horizontal centering */
  padding: 1rem;
  color: white;
  line-height: 1.2;
  background: #54565f !important;
}

.offline-image {
  filter: grayscale(100%);
}

.online-card {
  cursor: pointer;
}

.offline-card {
  cursor: not-allowed;
  background-color: #575757 !important;
}

.diagonal-top-offline::before {
  background: #575757;
}

@media (max-width: 1200px) {
  .diagonal-top {
    padding-top: 20px;
  }

  .diagonal-top::before {
    height: 100%;
    top: -20px;
  }

  .navDescription {
    width: 95%;
  }
}

@media (max-width: 650px) {
  .diagonal-top {
    padding-top: 20px;
  }

  .diagonal-top::before {
    height: 100%;
    top: -20px;
  }

  .navDescription {
    width: 88%;
  }

  .scenario-card {
    max-width: 90% !important;
  }
}
</style>